// $(document).ready(function(){
//   $(document).on('click','.KK_closeIcon',function(){
//     $('.KKpopform').fadeToggle(200);
//   }); 
//   $(document).on('click','#Enqure_tab',function(event){
//     event.preventDefault(); // Prevent default scroll behavior
//     $('.KKpopform').fadeToggle(300);
//   });
// });
$(document).ready(function(){
  $(document).on('click','.popup_closeIcon',function(){
    $('.KariEnquirPop_MainContaner').toggle(200);
    $('body').css('overflow', 'auto'); // Re-enable scrolling when closing the popup
  }); 
  $(document).on('click','#Enqure_tab',function(event){
    event.preventDefault(); // Prevent default scroll behavior
    
    $('.KariEnquirPop_MainContaner').fadeToggle(100);
    $('body').css('overflow', 'hidden'); // Disable scrolling when opening the popup
   
    if ($(window).width() > 749 ) {
      $('body').css('overflow', 'hidden'); // Disable scrolling when opening the popup
    } else {
      $('body').css('overflow', 'hidden'); // Enable scrolling when opening the popup
    }
  });

  
});
